import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerComponent } from './components/ngx-spinner/ngx-spinner.component';
import { CoreUtilsBaseApiModule } from '@brunsker/libs/core/utils/base-api';

@NgModule({
  imports: [
    CommonModule,
    NgxSpinnerModule,
    CoreUtilsBaseApiModule,
    NgxMaskDirective,
  ],
  declarations: [NgxSpinnerComponent],
  exports: [NgxSpinnerComponent],
  providers:[provideNgxMask()]

})
export class PortalDoVendedorUtilsBaseApiModule {}
